'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The public API for putting history on context.router.
 */
var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    _classCallCheck(this, Router);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: this.props.history
    };
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    (0, _invariant2.default)(children == undefined || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');

    return children ? _react2.default.Children.only(children) : null;
  };

  return Router;
}(_react2.default.Component);

Router.propTypes = {
  history: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.node
};
Router.childContextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = Router;


// WEBPACK FOOTER //
// ./~/react-router-dom/~/react-router/Router.js